// extracted by mini-css-extract-plugin
module.exports = {"main":"ProdottiListingTemplate_main__q75Lu","rotation":"ProdottiListingTemplate_rotation__OtaJc"};